<template>
	<div class="team1">
		<div class="reviews_left">
			<div class="reviews_left_title">Our Best <span>Instructor</span></div>
			<div class="reviews_left_tips">Various versions have evolved over the years, sometimes by accident,
			</div>
		</div>
		<div class="team_swiper">
			<div class="team_swiper_icon" @click="prevSlide" v-if="memberList.length>3">
				<i class="el-icon-arrow-left"></i>
			</div>
			<div ref="outside" class="team_swiper_outside">
				<div
					ref="track"
					class="team_swiper_outside2"
					:style="{ transform: `translateX(-${translatePx}px)` }"
				>
					<div class="team_swiper_box" v-for="(item,index) in memberList" :key="index"
						:class="{ 'first-item': index > 0 && index != 3 }">
						<div class="team_swiper_img">
							<el-image :src="item.avatar" style="width: 100%;height: 260px;border-radius: 20px;"
								fit="cover">
								<template v-slot:error>
									<div class="image-slot"
										style="position: absolute;top: 50%;transform: translateX(-50%);left: 48%;transform: translateY(-50%);">
										<i class="el-icon-picture-outline"></i>
									</div>
								</template>
							</el-image>
						</div>
						<div class="team_swiper_name">{{item.userName}}</div>
						<div class="team_swiper_Introduction">{{item.position_en}}</div>
					</div>
				</div>
			</div>
			<div class="team_swiper_icon" @click="nextSlide" v-if="memberList.length>3">
				<i class="el-icon-arrow-right"></i>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TeamPage2',
		data() {
			return {
				memberList: [],
				currentIndex: 0,
				visibleCount: 4, // 每次显示4条
				stepPx: 0,
				maxTranslatePx: 0,
			}
		},
		computed: {
			translatePx() {
				const raw = this.currentIndex * this.stepPx
				return Math.max(0, Math.min(raw, this.maxTranslatePx || 0))
			},
			maxIndex() {
				// 计算最大可切换的索引位置
				return Math.max(0, this.memberList.length - this.visibleCount)
			},
			trackWidth() {
				// 计算轨道总宽度，考虑首尾margin
				// let itemWidth = 0
				// itemWidth = 100 / this.visibleCount
				console.log((this.marginValue * 2 * 100), (this.$el?.offsetWidth || 1000))
				let marginPercent = (this.marginValue * 2 * 100) / (this.$el?.offsetWidth || 1000)
				return 100 + marginPercent
			}
		},
		methods: {
			prevSlide() {
				this.currentIndex = Math.max(0, this.currentIndex - 1)
			},
			nextSlide() {
				this.currentIndex = Math.min(this.maxIndex, this.currentIndex + 1)
			},
			updateStepPx() {
				this.$nextTick(() => {
					const track = this.$refs.track
					const outside = this.$refs.outside
					if (!track) return
					const first = track.querySelector('.team_swiper_box')
					if (!first) return
					// 卡片宽度 + gap（见 CSS）
					this.stepPx = first.offsetWidth + 20
					if (outside) {
						this.maxTranslatePx = Math.max(0, track.scrollWidth - outside.clientWidth)
					}
				})
			},
			getTeam() {
				this.$api.news.getMember().then((res) => {
					this.memberList = res.data.data
					let userLanguage = localStorage.getItem('userLanguage')
					this.memberList.forEach((item) => {
						if (userLanguage == 'en') {
							item.userName = item.name_en
							item.userPosition = item.position_en
							item.bio = item.bio_en
						} else {
							item.userName = item.name_zh
							item.userPosition = item.position_zh
							item.bio = item.bio_zh
						}
					})
					this.updateStepPx()
				})
			},
		},
		created() {
			this.getTeam()
			if (typeof window !== 'undefined') {
				window.addEventListener('resize', this.updateStepPx)
			}
		},
		beforeUnmount() {
			if (typeof window !== 'undefined') {
				window.removeEventListener('resize', this.updateStepPx)
			}
		}
	}
</script>

<style scoped>
	.team1 {
		margin-top: 86px;
		padding: 0 10%;
		box-sizing: border-box;
	}

	.team_swiper {
		margin-top: 60px;
		width: 100%;
		display: flex;
		align-items: center;
		position: relative;
		justify-content: space-between;
		flex-grow: 1
	}

	.team_swiper_icon {
		width: 44px;
		height: 44px;
		border-radius: 500%;
		background: rgba(255, 255, 255, 1);
		box-shadow: -4px 4px 20px rgba(32, 180, 134, 0.12);
		text-align: center;
		line-height: 44px;
	}

	.team_swiper_icon:hover {
		background: linear-gradient(180deg, rgba(255, 194, 122, 1) 0%, rgba(255, 163, 55, 1) 100%);
		color: white;
		cursor: pointer;
	}

	.team_swiper_outside {
		width: 90%;
		overflow: hidden;
		position: relative;
		/* 给右侧留白，避免最后一张卡片/阴影被裁切 */
		padding-right: 40px;
		box-sizing: border-box;
	}

	.team_swiper_outside2 {
		display: flex;
		transition: transform 0.5s ease;
		gap: 20px;
		width: fit-content;
	}

	.team_swiper_box {
		flex: 0 0 calc((100% - 60px) / 4);
		/* 每个卡片占25%宽度，确保4个可见 */
		/* width: 22%; */
		height: 370px;
		opacity: 1;
		box-sizing: border-box;
		padding: 16px;
		border-radius: 30px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 3px 12px rgba(75, 75, 75, 0.08);
	}

	.team_swiper_img {
		width: 100%;
		height: 260px;
		border-radius: 20px;
	}

	.team_swiper_name {
		margin-top: 16px;
		font-size: 20px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 28px;
		color: rgba(27, 29, 31, 1);
		text-align: center;
	}

	.team_swiper_Introduction {
		font-size: 16px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 24px;
		color: rgba(109, 115, 122, 1);
		text-align: center;
	}
	
	.reviews {
		margin-top: 116px;
		padding: 0 10%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.reviews_left_title {
		font-size: 32px;
		font-weight: 600;
		letter-spacing: 0px;
		line-height: 0px;
		color: rgba(0, 0, 0, 1);
	}
	
	.reviews_left_title span {
		color: rgba(52, 97, 253, 1);
	}
	
	.reviews_left_tips {
		font-size: 16px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 0px;
		color: rgba(0, 0, 0, 1);
		margin-top: 32px;
	}
	
</style>